import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=6a827129&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=6a827129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a827129",
  null
  
)

export default component.exports